module.exports = __webpack_public_path__ + "static/img/Product Page.d080d457.svg";